import React, { useMemo } from 'react';
import { Row, Col, ButtonGroup, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TableContainerReactTable from '../../../../Components/Common/TableContainerReactTable';

interface BinLocationData {
  area: string;
  binCode: string;
  quantity: number;
  pendingIn: number;
  pendingOut: number;
  available: number;
  active: boolean;
  seq: number;
  orderPoint: number;
  reorderQuantity: number;
  orderQtyMultiple: number;
  capacity: number;
}

const BinLocationTab = () => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [selectedLocation, setSelectedLocation] = React.useState('All Locations');
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleNew = () => {
    console.log('Creating new bin location...');
  };
  const handleSave = () => {
    console.log('Saving bin location...');
  };
  const handleCancel = () => {
    console.log('Cancelling changes...');
  };

  // Sample data
  const data: BinLocationData[] = [
    {
      area: 'A1',
      binCode: 'B001',
      quantity: 100,
      pendingIn: 10,
      pendingOut: 5,
      available: 105,
      active: true,
      seq: 1,
      orderPoint: 20,
      reorderQuantity: 50,
      orderQtyMultiple: 10,
      capacity: 200,
    },
    {
      area: 'A2',
      binCode: 'B002',
      quantity: 50,
      pendingIn: 0,
      pendingOut: 0,
      available: 50,
      active: false,
      seq: 2,
      orderPoint: 10,
      reorderQuantity: 20,
      orderQtyMultiple: 5,
      capacity: 100,
    },
  ];

  // Column definitions
  const columns = useMemo(
    () => [
      { header: 'Area', accessorKey: 'area', size: 80, enableColumnFilter: false },
      { header: 'Bin Code', accessorKey: 'binCode', size: 100, enableColumnFilter: false },
      { header: 'Quantity', accessorKey: 'quantity', size: 100, enableColumnFilter: false },
      { header: 'Pending In', accessorKey: 'pendingIn', size: 100, enableColumnFilter: false },
      { header: 'Pending Out', accessorKey: 'pendingOut', size: 100, enableColumnFilter: false },
      { header: 'Available', accessorKey: 'available', size: 100, enableColumnFilter: false },
      {
        header: 'Active',
        accessorKey: 'active',
        size: 80,
        enableColumnFilter: false,
        cell: (cell: any) => cell.getValue() ? (
          <div className="text-center"><i className="ri-checkbox-circle-line fs-17 align-middle"></i></div>
        ) : null,
      },
      { header: 'Seq', accessorKey: 'seq', size: 80, enableColumnFilter: false },
      { header: 'Order Point', accessorKey: 'orderPoint', size: 100, enableColumnFilter: false },
      { header: 'Reorder Quantity', accessorKey: 'reorderQuantity', size: 120, enableColumnFilter: false },
      { header: 'Order Qty Multiple', accessorKey: 'orderQtyMultiple', size: 120, enableColumnFilter: false },
      { header: 'Capacity', accessorKey: 'capacity', size: 100, enableColumnFilter: false },
    ],
    []
  );

  return (
    <div className="page-content p-0">
      <Row className="mb-3">
        <Col>
          <ButtonGroup className='gap-2'>
            <button  onClick={handleNew} className="d-inline-flex align-items-center btn btn-soft-primary btn-sm">
              <i className="ri-add-line align-middle me-1"></i> New
            </button>
            <button  onClick={handleSave} className="d-inline-flex align-items-center btn btn-soft-success btn-sm">
              <i className="ri-save-line align-middle me-1"></i> Save
            </button>
            <button   onClick={handleCancel} className="d-inline-flex align-items-center btn btn-soft-warning btn-sm">
              <i className="ri-close-line align-middle me-1"></i> Cancel
            </button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={3}>
          <label className="form-label mb-1">Location</label>
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} size="sm">
            <DropdownToggle caret color="light" className="w-50 text-start">
              {selectedLocation}
            </DropdownToggle>
            <DropdownMenu className="w-100">
              <DropdownItem onClick={() => setSelectedLocation('All Locations')}>All Locations</DropdownItem>
              <DropdownItem onClick={() => setSelectedLocation('A1')}>A1</DropdownItem>
              <DropdownItem onClick={() => setSelectedLocation('A2')}>A2</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
      <div className="bin-location-content">
        <TableContainerReactTable
          columns={columns}
          data={data}
          divClass="table-responsive"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
          verticalLines={true}
        />
      </div>
    </div>
  );
};

export default BinLocationTab;
